/** Focus Shopify's postback outcome without intercepting native submission. */
(function () {
  'use strict';

  class VsrContactForm extends HTMLElement {
    connectedCallback() {
      const feedback = this.querySelector('[data-contact-feedback]');
      if (!feedback) return;

      this.frame = window.requestAnimationFrame(() => {
        if (!this.isConnected) return;
        feedback.focus({ preventScroll: true });
        feedback.scrollIntoView({ block: 'nearest', behavior: 'instant' });
      });
    }

    disconnectedCallback() {
      window.cancelAnimationFrame(this.frame);
    }
  }

  if (window.VSR) window.VSR.define('vsr-contact-form', VsrContactForm);
  else if (!customElements.get('vsr-contact-form')) {
    customElements.define('vsr-contact-form', VsrContactForm);
  }
})();
